import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import { sessionManager } from './auth/session.js';
import { initialiseI18n } from './i18n/index.js';
import { applyTheme } from './ui/theme.js';
import '@fontsource-variable/alegreya';
import './ui/system.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Missing #root element');
}

// Tokens become CSS custom properties before the stylesheet is asked to use
// them, and localisation is ready before the first render, so that no frame is
// painted unstyled or in the wrong language.
applyTheme(document.documentElement);
await initialiseI18n();

// Nothing is persisted here any more: the refresh token is a cookie only the
// browser can read. Whether this tab is signed in is therefore a question for
// the server, asked once before the first render so that a returning parent
// does not see the sign-in screen flash past.
await sessionManager.restore();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
